// removed by extract-text-webpack-plugin
module.exports = {"heading":"ExternalIDPLoggedOut-hashed__heading__2xsP4","actionsWrapper":"ExternalIDPLoggedOut-hashed__actionsWrapper__3rFj2","button":"ExternalIDPLoggedOut-hashed__button__29YGu","error":"ExternalIDPLoggedOut-hashed__error__JPsMq","hasError":"ExternalIDPLoggedOut-hashed__hasError__sTaVB"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-angular/components/ExternalIDPLoggedOut/ExternalIDPLoggedOut-hashed.scss
// module id = 1152
// module chunks = 0